export enum EVENT2URL {
	registerSuccess = '/api/user/v1/accounts/email', //邮箱注册成功
	googleLoginSuccess = '/api/user/v1/accounts/google/login', // 谷歌注册成功
	facebookLoginSuccess = '/api/user/v1/accounts/facebook/login', // facebook注册成功
	phoneLoginSuccess = '/api/user/v1/accounts/phone/login', //手机号注册成功
	touristLoginSuccess = '/api/user/v1/accounts/tourist/login', // 游客注册成功
}

export enum EVENT3URL {
	loginSuccess = '/api/user/v1/accounts/email/login', //邮箱登录成功
	googleLoginSuccess = '/api/user/v1/accounts/google/login', // 谷歌登录成功
	phoneLoginSuccess = '/api/user/v1/accounts/phone/login', //手机号登录成功
	facebookLoginSuccess = '/api/user/v1/accounts/facebook/login', // facebook登陆成功
	touristLoginSuccess = '/api/user/v1/accounts/tourist/login', // 游客登录成功
}

export enum EVENT4URL {
	generateSuccess = '/api/resources/v1/images/test', //创建页生成图片
	generateSuccess2 = '/api/resources/v1/images/generate', //应用详情页生成图片
}

export enum EVENT6URL {
	accountCheck = '/api/user/v1/accounts', //用户查询
}
